/* Translated: yes */
export default {
  computed: {
    timelineSteps() {
      const steps = [];
      const $this = this;

      const skipasses = (
        this.$store.state.cart
        .skipasses.filter(a => a.type !== 'SKIPASS-ACCO')
        .length
      );

      const confirmedSkipasses = (
        this.$store.state.cart
        .skipasses.filter(a => a.guideCompleted && a.type === '')
        .length
      );

      this.$store.state.cart.skipasses.filter(a => a.type !== 'SKIPASS-ACCO').forEach((person, index) => {
        const no = index + 1;
        const skiier = this.$i18n.t('general.skier');
        const p = {
          title: (person.name || `${skiier} ${no}`),
          complete: 0,
          url: { name: 'ski pass person', params: { person: index }, query: $this.$route.query },
          clickable: person.guideCompleted,
        };

        if (person.guideCompleted) {
          p.complete = 2;
        }

        if (parseInt($this.$route.params.person, 10) === index) {
          p.complete = 1;
        }

        if ($this.currentIndex === index) {
          p.complete = 1;
        }

        steps.push(p);
      });

      steps.push({
        title: this.$i18n.t('general.cta.confirm'),
        complete: (confirmedSkipasses === skipasses ? 1 : 0),
        url: { name: 'ski pass overview', query: $this.$route.query },
        clickable: confirmedSkipasses,
      });

      return steps;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/skipassTimelineSteps.js